import { pipe } from 'fp-ts/function';
import { ord, string } from 'fp-ts';
import { CardPaymentMethod, PaymentCardState, PaymentPlan, SepaPaymentMethod } from '@mews-commander/data-access';
import { padStartZero, StructuredMonth } from '@optimus-web/core';
import { PaymentCardMethod } from '@mews-commander/legacy-entities/src/ducks/paymentCards';
import { UNSPECIFIED_CREDIT_CARD_VALUE } from '@mews-commander/legacy-entities/src/ducks/payments';
import { NEW_CREDIT_CARD_VALUE } from '../../constants';

export const sortByDate = pipe(
    ord.reverse(string.Ord),
    ord.contramap((p: PaymentCardMethod | SepaPaymentMethod) => p.createdUtc)
);

export const isPaymentCardExpired = (paymentCard: PaymentCardMethod, currentMonth: StructuredMonth) =>
    paymentCard.expiration && paymentCard.expiration < `${currentMonth.year}-${padStartZero(currentMonth.month + 1)}`;

export const isPaymentCardDisabled = (paymentCard: PaymentCardMethod) =>
    paymentCard.state === PaymentCardState.Disabled;

export const hasPaymentMethodIdAllowedValue = (
    paymentMethodId: string,
    paymentMethods: (CardPaymentMethod | SepaPaymentMethod)[],
    allowUnspecifiedCardValue: boolean
) =>
    paymentMethodId === NEW_CREDIT_CARD_VALUE ||
    (allowUnspecifiedCardValue && paymentMethodId === UNSPECIFIED_CREDIT_CARD_VALUE) ||
    paymentMethods.some(({ id }) => id === paymentMethodId);

export const getDefaultPaymentPlanId = (
    paymentPlansForSelectedReservation: PaymentPlan[],
    defaultFormPaymentPlanId: string | null | undefined
) => {
    if (paymentPlansForSelectedReservation.some(({ id }) => id === defaultFormPaymentPlanId)) {
        return defaultFormPaymentPlanId;
    }

    if (paymentPlansForSelectedReservation.length === 1) {
        return paymentPlansForSelectedReservation[0].id;
    }

    return undefined;
};
